"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SimpleQueryPathToBranchingQueryDef = void 0;
const iotv_v3_types_1 = require("@iotv/iotv-v3-types");
const GraphQuery_1 = require("./GraphQuery");
const SimpleQueryPathToBranchingQueryDef = ({ initialObjectTypeId, queryPath }) => {
    const apexQuery = new GraphQuery_1.BranchingQueryDefinition({
        id: `${initialObjectTypeId}-apexQuery`,
        path: [
            { objectTypeId: initialObjectTypeId, adjacencyType: iotv_v3_types_1.AdjacentType.SUBJECT, },
            ...queryPath
        ],
        subQueries: []
    });
    return apexQuery;
};
exports.SimpleQueryPathToBranchingQueryDef = SimpleQueryPathToBranchingQueryDef;
/* currently unsed */
const addSubStep = (parentStep, queryPath) => {
    const [thisQueryStep, ...nextSteps] = queryPath;
    const thisSubStep = new GraphQuery_1.BranchingQueryDefinition({
        id: `${parentStep.id}_${thisQueryStep.edgeTypeId ?? thisQueryStep.objectTypeId}`,
        path: [thisQueryStep],
        subQueries: []
    });
    parentStep.addSubQuery(thisSubStep);
    if (nextSteps) {
        addSubStep(thisSubStep, nextSteps);
    }
    return thisSubStep;
};
